module.exports = __webpack_public_path__ + "static/06-f229cf2abe31529cbefea9147b566853.jpg";